import React from "react"
import { Helmet } from "react-helmet-async"

function SearchResult(props) {
    const baseUrl = window.location.origin
    const pathname = window.location.pathname
    const canonicalUrl = pathname == "/" ? `${baseUrl}` : `${baseUrl}${pathname}`

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{props.title}</title>
                <meta name="description" content={props.description} />
                <meta property="og:title" content={props.title} />
                <link rel="canonical" href={canonicalUrl} />
                <meta property="og:type" content="article" />
                {props.image_name !== undefined ? <meta property="og:image" content={props.image_name} /> : null}
                {props.seo_url !== undefined ? <meta property="og:url" content={props.seo_url} /> : null}
                {props.cover_image !== undefined ? <meta property="og:image" content={props.cover_image} /> : null}
                {props.structuredData !== undefined ?
                    <script type="application/ld+json"> {JSON.stringify(props.structuredData)} </script>
                    : null}
            </Helmet>
        </>
    );
}

export default SearchResult;
